import {
  Dialog,
  DialogContent,
} from '@mui/material';
import DialogHeader from "./dialog-header"
import DialogFooter from './dialog-footer';

const DialogLayout = (props) => {
  const maxWidth = props.maxWidth || "670px"
  return (
    <Dialog
      onClose={props.disableOuterClose ? null : props.onClose}
      aria-labelledby="dialog-title"
      open={props.open}
      fullWidth={true}
      maxWidth={maxWidth}
      classes={{paper: `${props.classes} dialog-layout`}}
      fullScreen={props.fullScreen}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: maxWidth,
          borderRadius: '20px',
        }
      }}
    >
      <DialogHeader disable={props.isDisabled} title={props.title} onClose={props.onClose} />

      <DialogContent classes={{ root: "dialog-content" }}>
        {props.content}
      </DialogContent>

      {props.footerProps &&
        <DialogFooter onClose={props.onClose} onSubmit={props.onSubmit} {...props.footerProps} />
      }
    </Dialog>
  )
}

export default DialogLayout;
